// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ATl9ePrPv","name":"pUNQACaTvD","image":"_2V3tvX2u9z","info":"_2jF6Q4rVbZ","info-item":"c6kbC5nVhM","infoItem":"c6kbC5nVhM","description":"_1C5AxN-9Q2","links":"_3tAQeSBhd9"};
    if(module.hot) {
      // 1614934759517
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  